export default "__VITE_ASSET__elFMt6Ah__"